$('a[href^="#"]').on("click", function () {
  const speed = 500;
  const easing = "swing";
  const href = $(this).attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  const spt = parseInt($("html").css("scrollPaddingTop")) || 0;
  const smt = parseInt($(target).css("scrollMarginTop")) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $("html, body").animate({ scrollTop: position }, speed, easing);
  return false;
});

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $(".header").outerHeight(true);
if (urlHash) {
  $("body,html").stop().scrollTop(0);
  setTimeout(function () {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $("body,html").stop().animate(
      {
        scrollTop: position,
      },
      500
    );
  }, 100);
}

// SP nav
$(document).ready(function () {
  $(".js-nav-bt").on("click", function () {
    if ($(".js-nav-content").hasClass("is-navOn")) {
      $(".js-nav-content").removeClass("is-navOn");
      $(".js-nav-logo").removeClass("is-navOn");
      $(this).removeClass("is-navOn");
    } else {
      $(".js-nav-content").addClass("is-navOn");
      $(".js-nav-logo").addClass("is-navOn");
      $(this).addClass("is-navOn");
    }
  });
  $(".js-nav-bt.is-navOn, .js-nav-logo.is-navOn, .js-nav-link").on(
    "click",
    function () {
      $(
        ".js-nav-content.is-navOn, .js-nav-logo.is-navOn, .js-nav-bt.is-navOn"
      ).removeClass("is-navOn");
    }
  );
});

if (window.matchMedia("(max-width: 768px)").matches) {
  $(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $(".topMv").height();
      if (sliderHeight - 30 < $(this).scrollTop()) {
        $(".js-header-sp").addClass("is-headerOn");
      } else {
        $(".js-header-sp").removeClass("is-headerOn");
      }
    });
  });

  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });

  jQuery(function ($) {
    $(".js-sp-navDown").on("click", function () {
      $(this).next().slideToggle();
      $(this).toggleClass("is-on");
    });
  });
}

jQuery(function ($) {
  //tab
  $(function () {
    $(".js-tab .js-tabItem").click(function () {
      var index = $(".js-tab .js-tabItem").index(this);
      $(".js-tab .js-tabItem").removeClass("is-on");
      $(this).addClass("is-on");
      $(".js-tabArea .js-tabcCntents")
        .removeClass("is-on")
        .eq(index)
        .addClass("is-on");
    });
  });
});

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("is-visible");
    }
  });
});

document.querySelectorAll(".fadeUp").forEach((el) => {
  observer.observe(el);
});

// pullDown
$(document).ready(function () {
  $('.js-pullDown').on('click', function () {
    const $aItem = $(this).find('.aItem');
    $aItem.slideToggle(400);
    $aItem.toggleClass('is-pullOn');
    $(this).toggleClass('is-pullOn');
  });
});
